<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
    <LatestAnalysis v-if="!geoData" :data="data"></LatestAnalysis>
    <div class="headSectionIA">
      <span class="name">
        <translate>Sources</translate>
      </span>
      <div class="groupText">
        <span class="first"><translate>Websites and URLs most frequently mentioned in AI responses</translate></span>
        <div class="second"><translate :translate-params="{
    numberOfPrompts,
    numberOfResponses
  }">Analysis based on %{numberOfPrompts} prompts and %{numberOfResponses} responses.</translate></div>
      </div>

    </div>

    <div class="boxQuantities">
      <div class="">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17.414" viewBox="0 0 17 17.414">
          <g id="Grupo_24669" data-name="Grupo 24669" transform="translate(-1 -0.586)">
            <circle id="Elipse_648" data-name="Elipse 648" cx="7.5" cy="7.5" r="7.5" transform="translate(2 2)" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Trazado_18486" data-name="Trazado 18486" d="M11,2a10.875,10.875,0,0,0,0,15A10.875,10.875,0,0,0,11,2" transform="translate(-1.5)" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Trazado_18487" data-name="Trazado 18487" d="M2,12H17" transform="translate(0 -2.5)" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </g>
        </svg>

        <span class="quantity">{{ numberOfDomains | formatNumber(0,0) }}</span>
        <span><translate>Domains</translate></span>
      </div>
      <div class="">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18">
          <g id="Grupo_24673" data-name="Grupo 24673" transform="translate(-610 -265)">
            <g id="Grupo_24670" data-name="Grupo 24670" transform="translate(609 262)">
              <rect id="Rectángulo_5687" data-name="Rectángulo 5687" width="20" height="16" rx="2" transform="translate(2 4)" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Trazado_18488" data-name="Trazado 18488" d="M6,8h.01" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Trazado_18489" data-name="Trazado 18489" d="M10,8h.01" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Trazado_18490" data-name="Trazado 18490" d="M14,8h.01" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </g>
        </svg>

        <span class="quantity">{{ numberOfUrls | formatNumber(0,0) }}</span>
        <span><translate>URLs cited</translate></span>
      </div>
      <div class="">
        <svg xmlns="http://www.w3.org/2000/svg" width="22.006" height="22.151" viewBox="0 0 22.006 22.151">
          <g id="Grupo_24672" data-name="Grupo 24672" transform="translate(-901 -263)">
            <g id="Grupo_24671" data-name="Grupo 24671" transform="translate(900 262)">
              <path id="Trazado_18491" data-name="Trazado 18491" d="M13.172,2a2,2,0,0,1,1.414.586L21.3,9.3a2.4,2.4,0,0,1,0,3.408L16.7,17.3a2.4,2.4,0,0,1-3.408,0l-6.71-6.71A2,2,0,0,1,6,9.172V3A1,1,0,0,1,7,2Z" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Trazado_18492" data-name="Trazado 18492" d="M2,7v6.172a2,2,0,0,0,.586,1.414L9.3,21.3a2.4,2.4,0,0,0,3.191.193" fill="none" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <circle id="Elipse_649" data-name="Elipse 649" cx="0.5" cy="0.5" r="0.5" transform="translate(10 6)" fill="#f2f2f2" stroke="#8367df" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </g>
        </svg>

        <span class="quantity">{{ numberOfMentions | formatNumber(0,0) }}</span>
        <span><translate>Total mentions</translate></span>

      </div>
    </div>

    <div class="iaTabs">
      <button
        :class="{'active': tabActive === 'indirect'}"
        @click="tabActive = 'indirect'"
      ><translate>Indirect Prompts</translate></button>
      <button
        :class="{'active': tabActive === 'direct_generic'}"
        @click="tabActive = 'direct_generic'"
      ><translate>Direct Prompts</translate></button>
      <button
        :class="{'active': tabActive === 'direct_sectoral'}"
        @click="tabActive = 'direct_sectoral'"
      ><translate>Direct prompts with sectoral dimension</translate></button>
    </div>

    <div class="box p-0 mt-[16px]">
      <div class="tw-flex gap-2 justify-end p-[12px]">
        <Select
          :options="optionsFilterTyplogy"
          :optionSelected="optionTypology"
          :label="$gettext('Tipology')"
          :placeholder="$gettext('All')"
          @onSelect="optionTypology = $event"

        ></Select>
        <Select
          :options="optionsFilterCompetence"
          :optionSelected="optionCompetence"
          :label="$gettext('Competence')"
          :placeholder="$gettext('All')"
          @onSelect="optionCompetence = $event"

        ></Select>
        <Select
          v-if="tabActive === 'indirect'"
          :options="optionsFilterBrand"
          :optionSelected="optionBrand"
          :label="$gettext('Brand')"
          :placeholder="$gettext('All')"
          @onSelect="optionBrand = $event"

        ></Select>
      </div>
      <div class="grid gap-2 text-13  grid-cols-[40px_minmax(0,2fr)_minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] py-[12px]">
        <div class="text-center">#</div>
        <div class=""><translate>Website domain</translate></div>
        <div class="tw-flex gap-2 relative">
          <translate>URL typology</translate>
          <BoxHelpTypology :show="showHelpTypology" @update:show="showHelpTypology = $event"></BoxHelpTypology>

        </div>
        <div class="text-center"><translate>Competitive presence</translate></div>
        <div class="text-center">
          <span v-if="tabActive === 'indirect'">
                      <translate>Brand presence</translate>
          </span>
        </div>
        <div class="text-center"><translate>Number of times used</translate></div>
      </div>
      <div v-for="(sources, index) in referencesFiltered" :key="index" >
        <div class="grid gap-2 text-13 bg-[#EDE8FF] py-[12px] grid-cols-[40px_minmax(0,2fr)_minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)]"
             :class="{'border-b-[#fff]': !references[index].open, 'border-b-[#000]': references[index].open}">
          <div class="text-center">
            <button @click="references[index].open = !references[index].open"
                    :class="{'-rotate-90': !references[index].open}">
              <svg class="w-[15px]" xmlns="http://www.w3.org/2000/svg" width="17.121" height="9.311" viewBox="0 0 17.121 9.311">
                <path id="vector" d="M0,0,7.5,7.5,15,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>
            </button>

          </div>
          <div class="tw-flex gap-2">
            {{ index }}
            <span class="countUrls">{{ getNumberItemsFiltered(sources.items, true) }} Urls</span>
            <span></span>
          </div>
          <div>{{ sources.typology }}</div>
          <div class="tw-flex items-center justify-center">
            <img v-if="sources.competitors_found === 0" src="@/assets/img/IAReputation/xcircle.svg" />
            <img v-else-if="sources.competitors_found === 1" src="@/assets/img/IAReputation/check.svg" />
            <img v-else-if="sources.competitors_found === 0.5" src="@/assets/img/IAReputation/parcial.svg" />
          </div>
          <div class="tw-flex items-center justify-center">
            <img v-if="tabActive === 'indirect' && sources.brand_found === 0" src="@/assets/img/IAReputation/xcircle.svg" />
            <img v-else-if="tabActive === 'indirect' && sources.brand_found === 1" src="@/assets/img/IAReputation/check.svg" />
            <img v-else-if="tabActive === 'indirect' && sources.brand_found === 0.5" src="@/assets/img/IAReputation/parcial.svg" />
          </div>
          <div class="text-center">{{ numberOfMentionsByDomain(index) | formatNumber(0,0) }}</div>
        </div>
        <div v-if="references[index].open">
          <div class="grid text-11 gap-2 border-b border-b-[#f2f2f2] font-semibold"
               style="grid-template-columns: 40px minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr);">
            <div class="bg-[#F5F5F5] py-[12px]"></div>
            <div class="py-[12px]">Urls</div>
            <div class="border-r-[#f2f2f2] py-[12px]"><translate>Title</translate></div>
            <div></div>
            <div></div>
            <div class="text-center py-[12px]"><translate>Url Times used</translate></div>
          </div>
          <div v-for="(source, indexS) in getNumberItemsFiltered(references[index].items)" :key="indexS">
            <div v-if="indexS !== 'open'"
                 class="grid text-11 gap-2"
                 :class="{'border-b border-b-[#f2f2f2]': !source.open, 'border-b-[#8367DF]': source.open}"
                  style="grid-template-columns: 40px minmax(0px, 2fr) minmax(0px, 2fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr);">
              <div class="bg-[#F5F5F5]"></div>
              <div class="text-[#8367DF] tw-flex items-center gap-2"
              >
                <button @click="source.open = !source.open"
                :class="{'-rotate-90': !source.open}">
                  <svg class="w-[9px] min-w-[9px]" xmlns="http://www.w3.org/2000/svg" width="17.121" height="9.311" viewBox="0 0 17.121 9.311">
                    <path id="vector" d="M0,0,7.5,7.5,15,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                  </svg>
                </button>
                <a :href="source.url" class="sourceUrl" target="_blank">{{ source.url }}</a>
              </div>
              <div class="border-r-[#f2f2f2] py-[12px]">{{ source.title }}</div>
              <div class="tw-flex items-center justify-center">
                <img v-if="source.competitors?.total_matches > 0" src="@/assets/img/IAReputation/check.svg" />
                <img v-else-if="source.competitors?.total_matches === 0" src="@/assets/img/IAReputation/xcircle.svg" />
              </div>
              <div class="tw-flex items-center justify-center">
                <img v-if="source.brand_found" src="@/assets/img/IAReputation/check.svg" />
                <img v-else-if="!source.brand_found" src="@/assets/img/IAReputation/xcircle.svg" />
              </div>
              <div class="text-center tw-flex items-center justify-center">{{ source.count }}</div>
            </div>
            <div v-if="source.open">
              <div class="grid text-11 gap-2 border-b border-b-[#f2f2f2]"
                   style="grid-template-columns: 59px minmax(0px, 14.8fr) minmax(0px, 3fr);">
                <div class="bg-[#F5F5F5]"></div>
                <div class="border-r-[#f2f2f2] font-semibold py-[12px]">Prompt</div>
                <div class="border-r-[#f2f2f2] font-semibold text-center py-[12px]">LLMs</div>
              </div>
              <div v-for="(quote, index) in source.referenced_prompts"
                   :key="index"
                   class="grid text-11 gap-2 border-b border-b-[#f2f2f2]"
                   style="grid-template-columns: 59px minmax(0px, 14.8fr) minmax(0px, 3fr);">
                <div class="bg-[#F5F5F5]"></div>
                <div class="border-r-[#f2f2f2] py-[12px] tw-flex items-center gap-2">
                  <span class="flex-1"> {{ quote.text }}</span>
                  <button @click="showQuestion = true; dataQuestion = quote.text" style="margin-right: 8px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="15.5" viewBox="0 0 15.5 15.5">
                      <path id="Vector" d="M3.5,4.267h7M4.375,6.826h5.25M3.663,0h6.675A3.69,3.69,0,0,1,14,3.717V8.23a3.69,3.69,0,0,1-3.663,3.717H3.663L0,14V3.717A3.69,3.69,0,0,1,3.663,0Z" transform="translate(0.75 0.75)" fill="none" stroke="#9680e0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                    </svg>
                  </button>
                </div>
                <div class="text-center tw-flex gap-2 items-center">
                  <div v-for="(llm, index) in quote.providers" :key="index"
                       class="tw-flex flex-col gap-2 icoLLM text-center items-center justify-center w-[26px]">
                    <img :src="getLogoByLLM(llm, true)" class="h-[16px]" alt=""  />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>
      <ModalQuestion :data="data" :question="dataQuestion" :show="showQuestion" @update:show="showQuestion = $event"></ModalQuestion>

  </div>
  <span class="hidden"><translate>Tipology</translate></span>
  </div>

</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SrvIAReputationService from "@/services/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'
import ModalQuestion from "@/components/IAReputation/ModalQuestion.vue"
import BoxHelpTypology from "@/components/IAReputation/BoxHelpTypology.vue"
    import Select from "@/components/IAReputation/Select.vue"
export default {
  components: {LatestAnalysis, SkeletonCard, ModalQuestion, BoxHelpTypology, Select},
  mixins: [MixinIAReputation],
  props: ['geoData'],
  data() {
    return {
      data: null,
      loading: false,
      tabActive: 'indirect',
      showQuestion: false,
      dataQuestion: null,
      optionTypology: null,
      optionCompetence: null,
      optionBrand: null,
      showHelpTypology: false
    }
  },
  async mounted() {
    this.loading = true
    try {
      const process = (data) => {
        Object.keys(data.aggregated_references.by_type).forEach(e => {
          Object.keys(data.aggregated_references.by_type[e]).forEach(domain => {
            data.aggregated_references.by_type[e][domain] = {...data.aggregated_references.by_type[e][domain], open: false}
            data.aggregated_references.by_type[e][domain].items.forEach((item, index) => {
              data.aggregated_references.by_type[e][domain].items[index] = {...data.aggregated_references.by_type[e][domain].items[index], open: false}
            })
          })
        })
        return data
      }
      if (!this.geoData) {
        const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
        if (status === 200) {
          this.data = process(data)
        }
      } else {
        this.data = process(this.geoData)
      }
    } catch (e) {
      console.log(e)
    }
    this.loading = false
  },
  methods: {
    getNumberItemsFiltered(items, onlyLength = false) {
      let elements = items
      if (this.optionCompetence) {
        elements = elements.filter(e => {
          if (e.competitors?.total_matches === 0 && this.optionCompetence === 'no') {
            return  true
          }
          if (e.competitors?.total_matches > 0 && this.optionCompetence === 'si') {
            return  true
          }
          return false

        })
      }
      if (this.optionBrand) {
        elements = elements.filter(e => {
          if (!e.brand_found && this.optionBrand === 'no') {
            return  true
          }
          if (e.brand_found && this.optionBrand === 'si') {
            return  true
          }
          return false
        })
      }

      return onlyLength ? elements.length : elements
    },
    numberOfMentionsByDomain(domain) {
      if (!this.data || typeof domain === 'number' || domain === 'open') return 0
      let sum = 0
      Object.keys(this.data.aggregated_references.by_type[this.tabActive][domain]['items']).forEach(reference => {
        if (reference !== 'open') {
          sum += this.data.aggregated_references.by_type[this.tabActive][domain]['items'][reference].count
        }
      })
      return sum
    },
    numberOfUrlsByDomain(domain) {
      if (!this.data || typeof domain === 'number' || domain === 'open') return 0
      let sum = 0
      sum = this.data.aggregated_references.by_type[this.tabActive][domain].items
      return sum
    }
  },
  computed: {
    optionsFilterTyplogy() {
      if (!this.data) return []
      let uniques = [
        ...new Set(
          Object.keys(this.data.aggregated_references.by_type[this.tabActive]).map(e => this.data.aggregated_references.by_type[this.tabActive][e].typology)
        )
      ]
      uniques = uniques.map(e => {
        return {
          id: e,
          name: e
        }
      })
      uniques.unshift({id: null, name: this.$gettext('All')})
      return uniques
    },
    optionsFilterCompetence() {
      if (!this.data) return []
      return [{id: null, name: this.$gettext('All')},{id: 'si', name: this.$gettext('Yes')}, {id: 'no', name: this.$gettext('No')}]
    },
    optionsFilterBrand() {
      if (!this.data) return []
      return [{id: null, name: this.$gettext('All')},{id: 'si', name: this.$gettext('Yes')}, {id: 'no', name: this.$gettext('No')}]
    },
    referencesFiltered() {
      let filtered = this.references
      if (this.optionTypology) {
        let f = {}
        Object.keys(filtered).forEach((domain) => {
          if (filtered[domain].typology === this.optionTypology) {
            f[domain] = filtered[domain]
          }
        })
        filtered = f
      }
      if (this.optionCompetence) {
        let f = {}
        Object.keys(filtered).forEach((domain) => {
          if ((filtered[domain].competitors_found === 1 || filtered[domain].competitors_found === 0.5) && this.optionCompetence === 'si') {
            f[domain] = filtered[domain]
          }
          if (filtered[domain].competitors_found === 0 && this.optionCompetence === 'no') {
            f[domain] = filtered[domain]
          }
        })
        filtered = f
      }
      if (this.optionBrand) {
        let f = {}
        Object.keys(filtered).forEach((domain) => {
          if ((filtered[domain].brand_found === 1 || filtered[domain].brand_found === 0.5) && this.optionBrand === 'si') {
            f[domain] = filtered[domain]
          }
          if (filtered[domain].brand_found === 0 && this.optionBrand === 'no') {
            f[domain] = filtered[domain]
          }
        })
        filtered = f
      }
      return filtered
    },
    numberOfPrompts () {
      if (!this.data) return 0
      return Object.keys(this.data.reputation_index).length * (this.data.reputation_index['openai'].prompts_answers.direct.length + this.data.reputation_index['openai'].prompts_answers.indirect.length)
    },
    numberOfResponses () {
      if (!this.data) return 0
      return this.numberOfPrompts * Object.keys(this.data.reputation_index).length
    },
    references () {
      if (!this.data) return []
      //const coll = new Intl.Collator('es', { sensitivity: 'base' })
      let items = Object.entries(this.data.aggregated_references.by_type[this.tabActive] || {})
        .map(([domain], i) => ({
          domain,
          count: this.numberOfUrlsByDomain(domain),
          i
        }))
        .sort((A, B) => (B.count - A.count))
        .map(({ domain, count }) => ({ domain, count }))
      let domains = {}
      items.forEach(({ domain }) => {
        domains[domain] = this.data.aggregated_references.by_type[this.tabActive][domain]
      })
      return domains
    },
    numberOfDomains() {
      if (!this.data) return 0

      return Object.keys(this.data.aggregated_references.by_type[this.tabActive]).length
    },
    numberOfUrls() {
      if (!this.data) return 0
      let sum = 0
      Object.keys(this.data.aggregated_references.by_type[this.tabActive]).forEach(domain => {
          sum += Object.keys(this.data.aggregated_references.by_type[this.tabActive][domain].items).length - 1
      })

      return sum
    },
    numberOfMentions() {
      if (!this.data) return 0
      let sum = 0
      Object.keys(this.data.aggregated_references.by_type[this.tabActive]).forEach(domain => {
          Object.keys(this.data.aggregated_references.by_type[this.tabActive][domain].items).forEach(url => {
            if (url !== 'open') {
              this.data.aggregated_references.by_type[this.tabActive][domain]['items'][url].referenced_prompts.forEach(reference =>  {
                sum += reference.providers.length
              })
             }
        })
      })

      return sum
    }
  }
}
</script>
<style>
.countUrls{
  border-radius: 8px;
  font-size: 13px;
  background-color: #fff;
  border: 1px solid #707070;
  padding: 0 5px;
}

.boxQuantities{
  display: flex;
  font-size: 18px;
  background-color: #fff;
  border-radius: 4px;
  gap: 2rem;
  padding: 21px;
  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    .quantity{
     font-weight: 600;
    }
  }
}
</style>
